import { createSlice } from "@reduxjs/toolkit";
import {
  divisionData,
  DivisionInitialStatus,
} from "../../../../types/geo/geo";
import { capitalize } from "../../../../utils/string";
import {
  createDivisionAsync,
  deleteDivisionAsync,
  getAllDivisionListAsync,
  getSingleDivisionAsync,
  updateDivisionAsync,
} from "./divisionApi";

const initialState: DivisionInitialStatus<divisionData> = {
  loading: false,
  manageLoading: false,
  divisionList: [],
  singleDivisionData: null,
  countDivision: 0,
};

const divisionSlice = createSlice({
  name: "admin-division",
  initialState,
  reducers: {
    resetSingleDivision: (state) => {
      state.singleDivisionData = null;
    },
  },
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createDivisionAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createDivisionAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createDivisionAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllDivisionListAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllDivisionListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.divisionList = (action.payload?.data || []).map((item) => ({
          ...item,
          divisionName: capitalize(item.divisionName),
        }));
        state.countDivision = action.payload?.length || 0;
      })
      .addCase(getAllDivisionListAsync.rejected, (state) => {
        state.loading = false;
        state.divisionList = [];
        state.countDivision = 0;
      });

    // get single
    builder
      .addCase(getSingleDivisionAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleDivisionData = null;
      })
      .addCase(getSingleDivisionAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleDivisionData = action.payload
          ? {
              ...action.payload,
              divisionName: capitalize(action.payload.divisionName),
            }
          : null;
      })
      .addCase(getSingleDivisionAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleDivisionData = null;
      });

    // update
    builder
      .addCase(updateDivisionAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateDivisionAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateDivisionAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // delete
    builder
      .addCase(deleteDivisionAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(deleteDivisionAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(deleteDivisionAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export const { resetSingleDivision } = divisionSlice.actions;
export default divisionSlice;
